module.exports = __webpack_public_path__ + "static/media/platform.aa003e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/platform.png
// module id = 869
// module chunks = 13